/**
 * Las DOS herramientas de marketing que conviven durante la transición.
 *
 *  - **JR2 MKT** — la de hoy, una aplicación APARTE (mkt.jr2.es) a la que se
 *    entra por SSO desde el backend. Desde 09/2026 vive en el icono de la barra
 *    superior, ya no en el menú lateral.
 *  - **Marketing de JR2 OS** — la que se está construyendo aquí dentro, en la
 *    ruta `/marketing`. Es la que ocupa ahora la entrada «Marketing» del menú.
 *
 * La URL del SSO y quién puede usarlo se declaran UNA sola vez aquí porque los
 * consumen dos sitios (la barra superior y la propia página de Marketing).
 * Duplicarlos sería garantizar que un día uno de los dos apunte a otro lado.
 */

/**
 * Handoff SSO hacia JR2 MKT. Es navegación REAL del navegador contra el
 * backend (`routes/marketing-sso.ts`), NO una ruta de react-router: hay que
 * usarla con `<a href>` o `window.open`, nunca con `<Link>`/`navigate`.
 */
export const MKT_SSO_URL = '/api/marketing-sso'

/**
 * Quién puede saltar a JR2 MKT: todos menos la gestoría (CONTABILIDAD), que
 * tampoco veía la entrada del menú porque el suyo es una whitelist.
 *
 * Esto NO es el control de acceso —un icono que no se dibuja no impide teclear
 * la URL—: el de verdad está en `apps/api/src/routes/marketing-sso.ts`, que
 * responde 403. Esto solo evita ofrecer un enlace que va a dar 403. Misma lista
 * blanca que allí, y en el mismo orden, para que se vea de un vistazo que
 * coinciden; si cambia una, cambia la otra.
 */
const MKT_ROLES = ['ADMIN', 'CONSULTOR', 'ANALISTA', 'LECTURA']

export function canOpenMktTool(role: string | null | undefined): boolean {
  return Boolean(role) && MKT_ROLES.includes(role as string)
}

/**
 * Cuando `SSO_SHARED_SECRET` no está configurado (hoy: la demo), el backend no
 * puede firmar el handoff y devuelve al usuario a `/marketing?mkt=unavailable`
 * en vez de a un JSON 404 en una pestaña en blanco. Contrato compartido con
 * `apps/api/src/routes/marketing-sso.ts`: si cambia ahí, cambia aquí.
 */
export const MKT_UNAVAILABLE_PARAM = 'mkt'
export const MKT_UNAVAILABLE_VALUE = 'unavailable'
